module.exports = __webpack_public_path__ + "img/defaultApp.c814c703.png";